import { render, staticRenderFns } from "./Cbtexamsubject.vue?vue&type=template&id=efa9e7d0"
import script from "./Cbtexamsubject.vue?vue&type=script&lang=js"
export * from "./Cbtexamsubject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports